"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertDraftRegistrationSchema = exports.abandonDraftRegistrationSchema = exports.listDraftRegistrationsSchema = exports.updateDraftRegistrationSchema = exports.createDraftRegistrationSchema = void 0;
/**
 * Draft registration — a person who has an appointment but no UHID yet.
 *
 * The capture form is deliberately two fields plus an optional surname. The
 * front desk takes these over the phone, and every extra required field is
 * another reason the booking never gets recorded at all.
 */
const zod_1 = require("zod");
exports.createDraftRegistrationSchema = zod_1.z.object({
    givenName: zod_1.z.string().min(1).max(150),
    /** Optional — chasing a surname on a phone call is how the booking is lost. */
    familyName: zod_1.z.string().max(150).optional(),
    /**
     * An Indian mobile number: ten digits starting 6-9, optionally prefixed with
     * +91 / 91 / 0, and normalised to the bare ten digits.
     *
     * The previous `min(6).max(20)` accepted "abcdef" and twenty characters of
     * anything — a phone booking whose only means of contact is the number is
     * exactly where a junk value costs the most, because nobody discovers it
     * until they try to ring back.
     */
    mobile: zod_1.z
        .string()
        .trim()
        .transform((value) => value.replace(/[\s-()]/g, '').replace(/^(\+?91|0)/, ''))
        .pipe(zod_1.z
        .string()
        .regex(/^[6-9]\d{9}$/, 'Enter a 10-digit Indian mobile number starting with 6, 7, 8 or 9')),
    notes: zod_1.z.string().max(2000).optional(),
});
exports.updateDraftRegistrationSchema = exports.createDraftRegistrationSchema.partial();
exports.listDraftRegistrationsSchema = zod_1.z.object({
    status: zod_1.z.enum(['DRAFT', 'CONVERTED', 'ABANDONED']).optional(),
    /** Matches name or mobile — what the desk has when someone calls back. */
    search: zod_1.z.string().max(150).optional(),
    limit: zod_1.z.coerce.number().int().positive().max(200).optional(),
});
exports.abandonDraftRegistrationSchema = zod_1.z.object({
    reason: zod_1.z.string().max(2000).optional(),
});
/**
 * Conversion payload — a full registration. The draft's captured name and
 * mobile are defaults, not limits: whatever the counter confirms wins, because
 * that is the corrected version of what a phone call captured.
 */
exports.convertDraftRegistrationSchema = zod_1.z.object({
    givenName: zod_1.z.string().min(1).max(150).optional(),
    familyName: zod_1.z.string().max(150).optional(),
    dateOfBirth: zod_1.z.coerce.date().optional(),
    genderId: zod_1.z.string().uuid().optional(),
    patientCategory: zod_1.z.string().optional(),
    primaryBranchId: zod_1.z.string().uuid().optional(),
    contacts: zod_1.z
        .array(zod_1.z.object({
        contactType: zod_1.z.enum(['PHONE', 'EMAIL']),
        value: zod_1.z.string().min(1).max(255),
        isPrimary: zod_1.z.boolean().optional(),
    }))
        .optional(),
});
//# sourceMappingURL=draft-registration.request.js.map